export default [
  {
    path: "/myOrder/orderDetail",
    name: "orderDetail",
    meta: {
      title: "订单详情",
      keepAlive: false,
      home: true
    },
    component: () => import("@views/myOrder/orderDetail")
  },
  {
    path: "/myOrder/orderList/:type",
    name: "orderList",
    meta: {
      title: "我的订单",
      keepAlive: false,
      home: false
    },
    component: () => import("@views/myOrder/orderList")
  },
  {
    path: "/myOrder/dispatchList/:type",
    name: "dispatchList",
    meta: {
      title: "我的收货单",
      keepAlive: false,
      home: false
    },
    component: () => import("@views/myOrder/dispatchList")
  },
  {
    path: "/myOrder/cusConfirmDetails/:orderId",
    name: "cusConfirmDetails",
    meta: {
      title: "用户订单确认",
      keepAlive: false,
      home: true
    },
    component: () => import("@views/myOrder/cusConfirmDetails")
  },
  {
    path: "/myOrder/cusCheckDetails/:orderId/:token",
    name: "cusCheckDetails",
    meta: {
      title: "用户订单确认",
      keepAlive: false,
      home: false,
      auth: false
    },
    component: () => import("@views/myOrder/cusCheckDetails")
  },
  {
    path: "/myOrder/saleAfterCheck/:orderId/:token",
    name: "cusCheckDetails",
    meta: {
      title: "用户退货单确认",
      keepAlive: false,
      home: false,
      auth: false
    },
    component: () => import("@views/myOrder/saleAfterCheck")
  },
  {
    path: "/myOrder/dispatchBill",
    name: "dispatchBill",
    meta: {
      title: "发货单详情",
      keepAlive: false,
      home: true
    },
    component: () => import("@views/myOrder/dispatchBill")
  },
  {
    path: "/myOrder/print/:orderId/:token",
    name: "print",
    meta: {
      title: "打印配货",
      keepAlive: false,
      home: false,
      auth: false
    },
    component: () => import("@views/myOrder/print")
  },
  {
    path: "/myOrder/printHasmoney/:orderId/:token/:type",
    name: "printHasmoney",
    meta: {
      title: "打印发货",
      keepAlive: false,
      home: false,
      auth: false
    },
    component: () => import("@views/myOrder/printHasmoney")
  },
  {
    path: "/thOrder/print/:orderId/:token",
    name: "thOrderPrint",
    meta: {
      title: "打印退货",
      keepAlive: false,
      home: false,
      auth: false
    },
    component: () => import("@views/thOrder/print")
  },
  {
    path: "/myOrder/serviceOrder/:type",
    name: "serviceOrder",
    meta: {
      title: "售后单列表",
      keepAlive: false,
      home: false
    },
    component: () => import("@views/myOrder/serviceOrder")
  },
  {
    path: "/myOrder/serviceOrderConfirm/:orderAfterId",
    name: "serviceOrderConfirm",
    meta: {
      title: "售后单确认",
      keepAlive: false,
      home: true
    },
    component: () => import("@views/myOrder/serviceOrderConfirm")
  },
  {
    path: "/myOrder/serviceOrderDetail",
    name: "serviceOrderDetail",
    meta: {
      title: "售后单详情",
      keepAlive: false,
      home: true
    },
    component: () => import("@views/myOrder/serviceOrderDetail")
  },
  {
    path: "/order/list/:type?",
    name: "MyOrder",
    meta: {
      title: "我的订单",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/MyOrder")
  },
  {
    path: "/order/logistics/:id",
    name: "Logistics",
    meta: {
      title: "物流信息",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/Logistics")
  },
  {
    path: "/order/detail/:id",
    name: "OrderDetails",
    meta: {
      title: "订单详情",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/OrderDetails")
  },
  {
    path: "/order/submit/:id",
    name: "OrderSubmission",
    meta: {
      title: "提交订单",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/OrderSubmission")
  },
  {
    path: "/order/status/:id/:status",
    name: "PaymentStatus",
    meta: {
      title: "支付状态",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/PaymentStatus")
  },
  {
    path: "/order/refund/:id",
    name: "GoodsReturn",
    meta: {
      title: "申请退货",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/GoodsReturn.vue")
  },
  {
    path: "/order/refund_list",
    name: "ReturnList",
    meta: {
      title: "退货列表",
      keepAlive: false
      // auth: true
    },
    component: () => import("@views/order/ReturnList.vue")
  }
];
